var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156 144H132V136H156V144ZM172 116V176H116V116H132V112H156V116H172ZM164 124H156V128H132V124H124V168H164V124ZM156 152H132V160H156V152ZM159.694 104C154.153 94.445 143.818 88 132 88C114.355 88 100 102.356 100 120C100 128.094 103.026 135.49 108 141.132V151.968C102.905 148.138 98.7923 143.153 96 137.423C89.512 150.774 75.814 160 60 160C37.944 160 20 142.056 20 120C20 97.944 37.944 80 60 80C61.417 80 62.817 80.077 64.196 80.221C59.06 73.493 56 65.1 56 56.001C56 33.945 73.944 16.001 96 16.001C118.056 16.001 136 33.945 136 56.001C136 65.099 132.94 73.493 127.804 80.221C129.198 80.0747 130.598 80.0012 132 80.001C148.368 80.001 162.464 89.888 168.65 104.001L159.694 104ZM92 120C92 102.356 77.645 88 60 88C42.355 88 28 102.356 28 120C28 137.644 42.355 152 60 152C77.645 152 92 137.645 92 120ZM128 56C128 38.356 113.644 24 96 24C78.356 24 64 38.356 64 56C64 73.644 78.355 88 96 88C113.645 88 128 73.645 128 56Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialList);
export default __webpack_public_path__ + "static/media/material-list.8fb2476d523acd99deb9353d49adc111.svg";
export { ForwardRef as ReactComponent };